import React from "react";

import useNavigation from "../hooks/useNavigation";

import SchoolMobileMegaMenuView from "./views/SchoolMobileMegaMenuView";
import SchoolMobileSectionView from "./views/SchoolMobileSectionView";
import SchoolMobileLinksView from "./views/SchoolMobileLinksView";

const SchoolMobileView = () => {
  const { currentView } = useNavigation();

  if (!currentView) {
    return null;
  }

  switch (currentView.type) {
    case "megaMenu":
      return (
        <SchoolMobileMegaMenuView
          view={currentView}
        />
      );

    case "section":
      return (
        <SchoolMobileSectionView
          view={currentView}
        />
      );

    case "links":
      return (
        <SchoolMobileLinksView
          view={currentView}
        />
      );

    default:
      return null;
  }
};

export default SchoolMobileView;